import React from 'react'
import { Button, Text, Box } from '@deseretbook/react-ui'
import { useMediaQuery } from '@deseretbook/react-utils'
import CrownIcon from '@deseretbook/icons/react/crown'

/**
 * The rewards button that links to the rewards page
 *
 * @returns {function} React component
 */
export const RewardsButton = () => {
  const isTabletOrLarger = useMediaQuery({ minWidth: 992 })

  return (
    <Button
      type="button"
      color="secondary"
      as="a"
      href="/rewards"
      size="small"
      title="rewards"
      // To keep the text from being ellipsified
      style={{
        minWidth: isTabletOrLarger ? '7rem' : '2.5rem',
        marginRight: isTabletOrLarger ? '0.5rem' : '0.25rem',
      }}
    >
      <Box alignItems="center">
        {isTabletOrLarger && (
          <Text
            color="light"
            display="inline-block"
            size="small"
            as="span"
            style={{
              marginRight: '0.25rem',
            }}
          >
            Rewards
          </Text>
        )}
        <CrownIcon width="1.5em" height="1.5em" />
      </Box>
    </Button>
  )
}
